export default {
  //バリデーション
  SUBMIT_ERROR_TITLE: "Error / エラー",
  VALIDATION_EMPTY_MAIL_ADDRESS: "メールアドレスを入力してください。",
  VALIDATION_INVALID_ADDRESS: "メールアドレスの形式が不正です。",
  VALIDATION_EMPTY_PASSWORD: "パスワードを入力してください。",
  VALIDATION_INVALID_PASSWORD: "半角英数字を組み合わせた８文字以上で入力してください。",
  VALIDATION_UNMATCH_PASSWORD: "パスワードが一致しません。再度入力してください。",
};
